import { Navigate } from 'react-router-dom'

/** Legacy 8-step refinement bookmarks — unified workbench is Step 5. */
export default function VirtualIpLegacyCharacterRefinementRedirect() {
  return <Navigate to="../step-5" replace />
}
